import { AnimationClassNames, getGlobalClassNames, getTheme, mergeStyles, useTheme } from "@fluentui/react";
import * as React from "react";

const theme = getTheme();

/**
 * The error list field component properties
 */
export interface IErrorListFieldProps {
  /**
   * The root element ID
   */
  id: string;

  /**
   * The raw validation errors
   */
  rawErrors: string[];
}

const classNames = getGlobalClassNames(
  {
    errorMessage: "error-detail",
  },
  theme
);

/**
 * Gets the best error to show the user
 *
 * @param errors - the list of errors
 * @returns the best error to show the suer
 */
const getBestError = (errors: string[] | undefined): string => {
  return errors ? errors[0] : "";
};

/**
 * The custom ErrorList field
 *
 * @param props - the component properties
 * @returns - the error list JSX
 */
export const ErrorListField: React.FC<IErrorListFieldProps> = (props) => {
  const { id, rawErrors } = props;
  const errorMessage = getBestError(rawErrors);
  const currentTheme = useTheme();
  const errorMessageStyle = mergeStyles(classNames.errorMessage, AnimationClassNames.slideDownIn20, currentTheme.fonts.small, {
    color: currentTheme.semanticColors.bodyBackground === "#1e1e1e" ? "#ff5161" : currentTheme.semanticColors.errorText,
    margin: 0,
    paddingTop: 5,
    display: "flex",
    alignItems: "center",
  });
  return (
    <>
      {errorMessage && (
        <p id={id} className={errorMessageStyle} role="alert" aria-label={errorMessage}>
          <span aria-hidden="true" data-automation-id="error-message">
            {errorMessage}
          </span>
        </p>
      )}
    </>
  );
};
